module.exports = __webpack_public_path__ + "img/grenada.82ac517d.svg";